"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var LandingPage_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingPage = void 0;
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const sioc_1 = require("lincd-sioc/lib/ontologies/sioc");
const models_1 = require("lincd/lib/models");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const package_1 = require("../package");
const Shape_1 = require("lincd/lib/shapes/Shape");
const dc_1 = require("lincd-dcmi/lib/ontologies/dc");
const rdf_1 = require("lincd-rdf/lib/ontologies/rdf");
let LandingPage = LandingPage_1 = class LandingPage extends Shape_1.Shape {
    constructor(nodeOrLandingPageURL) {
        if (nodeOrLandingPageURL instanceof models_1.NamedNode) {
            super(nodeOrLandingPageURL);
        }
        else {
            const timestamp = Date.now().toString().slice(1);
            const URI = process.env.DATA_ROOT + '/' + timestamp + '/' + nodeOrLandingPageURL;
            const node = models_1.NamedNode.getOrCreate(URI, true);
            node.overwrite(rdf_1.rdf.type, sioc_1.sioc.Site);
            super(node);
            this.url = nodeOrLandingPageURL;
        }
    }
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', LandingPage_1.shape.namedNode);
    }
    static getAllPageNamesByURL(url) {
        return LandingPage_1.getLocalInstances().filter((a) => {
            return a.url === url;
        });
    }
    get name() {
        return this.getValue(dc_1.dcelems.title);
    }
    set name(val) {
        this.overwrite(dc_1.dcelems.title, new models_1.Literal(val));
    }
    get url() {
        return this.getValue(sioc_1.sioc.links_to);
    }
    set url(val) {
        this.overwrite(sioc_1.sioc.links_to, new models_1.Literal(val));
    }
};
exports.LandingPage = LandingPage;
LandingPage.targetClass = sioc_1.sioc.Site;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.title,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LandingPage.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.links_to,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LandingPage.prototype, "url", null);
exports.LandingPage = LandingPage = LandingPage_1 = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [Object])
], LandingPage);
//# sourceMappingURL=LandingPage.js.map